import type { Organism } from "../graphql.js";
import type { IMutantGenome } from "../redux/modules/genome-browser.js";

export function organismToMutantGenome(organism: Organism): IMutantGenome {
  return {
    id: organism.id,
    name: organism.name,
    highlighted: false,
  };
}

export function getCompatibleRefGenome(defaultRefGenomeId: number | undefined | null, refGenomes: Organism[]) {
  // first take the one from the session parameter
  let refGenomeId: number | undefined | null = defaultRefGenomeId;

  // if it does not fit the current genome analysis group, use the first one from the analysis group
  if (refGenomes && refGenomes.length > 0 && !refGenomes.find((o: Organism) => o.id === refGenomeId)) {
    refGenomeId = refGenomes[0].id;
  }

  return refGenomeId;
}
